import { css } from 'styled-system/css';
import { DataRow } from './DataRow';
import { EmptyRow } from './EmptyRow';
import { HeaderRow } from './HeaderRow';
import {
  COLS,
  NARROW_HEAD,
  ROWS,
  WIDE_HEAD,
  parseSheetRange,
} from './sheetData';

export function SheetGrid({
  selected,
  selectedCell,
  proposalRange,
  commentedRow,
  soft,
  wide,
}: {
  selected: number;
  selectedCell?: { row: number; col: number };
  proposalRange?: string;
  commentedRow?: number;
  soft?: boolean;
  wide?: boolean;
}) {
  const cols = wide ? COLS : COLS.slice(0, 3);
  const head = wide ? WIDE_HEAD : NARROW_HEAD;
  const proposal = proposalRange ? parseSheetRange(proposalRange) : undefined;

  return (
    <div
      data-wide={wide || undefined}
      className={css({
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        fontFamily: 'sans',
        fontSize: '2xs',
        background: 'bg.surface',
      })}
    >
      <div
        data-wide={wide || undefined}
        data-soft={soft || undefined}
        className={css({
          display: 'grid',
          gridTemplateColumns:
            '36px minmax(0, 1.2fr) minmax(0, 1fr) minmax(0, 1fr)',
          borderBottom: '1px solid token(colors.border.hairline)',
          color: 'text.faint',
          flexShrink: 0,
          background: 'bg.sunken',
          '&[data-wide]': {
            gridTemplateColumns: '47px repeat(7, 64px)',
          },
          '&[data-soft]': {
            background: 'transparent',
          },
        })}
      >
        <span />
        {cols.map((col, c) => (
          <span
            key={col}
            data-active={selectedCell?.col === c || undefined}
            className={css({
              paddingInline: '2',
              paddingBlock: '1',
              borderLeft: '1px solid token(colors.border.hairline)',
              textAlign: 'center',
              fontWeight: 'semibold',
              fontSize: '2xs',
              '&:last-child': {
                borderRight: '1px solid token(colors.border.hairline)',
              },
              '&[data-active]': {
                color: 'text.primary',
                background: 'bg.subtle',
              },
            })}
          >
            {col}
          </span>
        ))}
      </div>
      <HeaderRow labels={head} wide={wide} soft={soft} />
      {ROWS.map((row, i) => (
        <DataRow
          key={row.ticker}
          index={i + 2}
          row={row}
          wide={wide}
          soft={soft}
          selected={selected === i}
          selectedCol={selectedCell?.row === i ? selectedCell.col : undefined}
          proposal={
            proposal && i + 2 >= proposal.startRow && i + 2 <= proposal.endRow
              ? { startCol: proposal.startCol, endCol: proposal.endCol }
              : undefined
          }
          commented={commentedRow === i}
        />
      ))}
      {Array.from({ length: wide ? 10 : 4 }, (_, i) => (
        <EmptyRow
          key={i}
          n={i + ROWS.length + 2}
          wide={wide}
          soft={soft}
          cols={head.length}
        />
      ))}
    </div>
  );
}
